import React from "react";
import icon from "./../../assets/S10Icon.png";

const S10Icon = () => {
  return (
    <>
      <img src={icon} alt="S10 Icon" style={{ cursor:"pointer", height: "15px" }} />
    </>
  );
};

export default S10Icon;
